<template>
    <div :class="` animated ${showNoteForm ? 'faster fadeInDown' : 'slow fadeOutUp'}`">
        <FormSection :application-id="application" :showBackground="false">
            <template #content>
                <div class="p-3 px-4">
                    <div class="form-group col-6">
                        <label for="title">
                            Title
                            <span class="text-danger ms-1">*</span>
                        </label>
                        <input
                            class="form-control"
                            name="title"
                            type="text"
                            placeholder="Enter Title"
                            v-model="newNote.title"
                            :disabled="isReadOnly"
                            maxlength="50"
                            @blur="v$.newNote.title.$touch"
                            :class="`${!v$.newNote.title.$error ? '' : 'field-invalid'}`"
                        />
                        <span v-if="v$.newNote.title.$error" class="field-invalid">Title is required.</span>
                    </div>
                    <div class="form-group col-9" v-if="showTemplateTypeahead && !isApplicationPalliative">
                        <NewTypeahead
                            v-model:selected-option="selectedTemplate"
                            :fetch-options="getTemplateList"
                            placeholder="Enter Preadmission Notes Template"
                            :search-char-limit="3"
                            :disabledProp="isReadOnly"
                        >
                        </NewTypeahead>
                    </div>
                    <div class="form-group col-12">
                        <label for="notes">
                            Notes
                            <span class="text-danger ms-1">*</span>
                        </label>
                        <textarea
                            class="form-control"
                            name="notes"
                            type="text"
                            placeholder="Enter Preadmission Notes"
                            v-model="newNote.notes"
                            :disabled="isReadOnly"
                            maxlength="2000"
                            @blur="v$.newNote.notes.$touch"
                            :class="`${!v$.newNote.notes.$error ? '' : 'field-invalid'}`"
                        >
                        </textarea>
                        <span v-if="v$.newNote.notes.$error" class="field-invalid">Notes is required.</span>
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                    <template v-if="!isReadOnly">
                        <button type="button" class="btn btn-primary me-2 mb-2" @click="saveNote()">Save</button>
                        <button type="button" class="btn btn-outline-primary mb-2" @click="closeNoteForm()">
                            Cancel
                        </button>
                    </template>
                    <template v-else>
                        <button type="button" class="btn btn-outline-primary mb-2" @click="closeNoteForm()">
                            Close
                        </button>
                    </template>
                </div>
            </template>
        </FormSection>
    </div>
</template>

<script lang="ts" src="./PatientPreadmissionNotesForm.ts"></script>
